import { ImgHTMLAttributes } from "react";

import {
  createImageFromInitials,
  getRandomColor,
} from "../utils/utilFunctions";

interface AvatarProps extends ImgHTMLAttributes<HTMLImageElement> {
  url: string;
  fullName: string;
}

const Avatar = ({ url, fullName, ...props }: AvatarProps) => (
  <img
    className={"img-parent-div img-width-90"}
    src={url || createImageFromInitials(500, fullName, getRandomColor())}
    alt={fullName}
    {...props}
  />
);

export default Avatar;
